import React from "react";
import UserBalanceDetails from "../components/allcustomers";
export function AllCustomeresPage() {
  return (
    <div>
      <UserBalanceDetails />
    </div>
  );
}
export default AllCustomeresPage;
